export enum DocumentStatus {
        Unknown,
        Valid,
        Expired,
        Missing,
        Deleted,
        Sent,
        NotRequired
}
